export default "<router-outlet></router-outlet> <app-alert></app-alert>\r\n";